import styled from "styled-components";

export const StakingBadgeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
